import type { Doc } from "building-types/doc";
import diffObjects from "common/utils/diffObjects";
import type { JSONPatchDocument } from "immutable-json-patch";
import { immutableJSONPatch } from "immutable-json-patch";
import type { DocDelta, InitDocDelta, PatchDocDelta } from "./docDeltaTypes";
import type { Editor } from "./editorTypes";

// Re-export types for backwards compatibility
export type { DocDelta, InitDocDelta, PatchDocDelta } from "./docDeltaTypes";

export function docInitDelta(doc: Doc): InitDocDelta {
  return {
    type: "INIT",
    doc,
  };
}

export function docComputePatch(oldDoc: Doc, newDoc: Doc): PatchDocDelta {
  return {
    type: "PATCH",
    patch: diffObjects(oldDoc, newDoc),
  };
}

export function docComputeDelta(oldDoc: Doc | undefined, newDoc: Doc): DocDelta {
  if (oldDoc === undefined) {
    return docInitDelta(newDoc);
  }

  return docComputePatch(oldDoc, newDoc);
}

export function docApplyDelta(oldDoc: Doc | undefined, docDelta: DocDelta): Doc {
  if (docDelta.type === "INIT") {
    return docDelta.doc;
  } else {
    return immutableJSONPatch(oldDoc, docDelta.patch as JSONPatchDocument) as Doc;
  }
}

export function replayEntityQueueDelta(editor: Editor, oldDoc: Doc) {
  const { doc, replayEntityQueue } = editor;
  const delta: DocDelta = docComputePatch(oldDoc, doc);

  if (replayEntityQueue && delta.patch && delta.patch.length > 0) {
    delta.patch.forEach((operation) => {
      const pathSegments = operation.path.split("/").filter(Boolean);
      const entityId = pathSegments[pathSegments.length - 1];

      if (operation.op === "remove") {
        replayEntityQueue.removeById(entityId);
      } else if (operation.op === "add" && operation.value) {
        replayEntityQueue.enqueue(operation.value);
      }
    });
  }

  return replayEntityQueue;
}
